import { useMemo } from "react";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useGoalCategoryLabels = () => {
	const { t } = useResource();

	return useMemo(
		(): Record<GoalCategoryTypeEnum, string> => ({
			[GoalCategoryTypeEnum.House]: t(Resources.Goals.Form.Categories.Housing),
			[GoalCategoryTypeEnum.Car]: t(Resources.Goals.Form.Categories.Car),
			[GoalCategoryTypeEnum.Pension]: t(
				Resources.Goals.Form.Categories.Retirement,
			),
			[GoalCategoryTypeEnum.Rent]: t(Resources.Goals.Form.Categories.Rent),
			[GoalCategoryTypeEnum.Student]: t(
				Resources.Goals.Form.Categories.Education,
			),
			[GoalCategoryTypeEnum.Vacation]: t(
				Resources.Goals.Form.Categories.Vacation,
			),
			[GoalCategoryTypeEnum.Basic]: t(Resources.Goals.Form.Categories.Custom),
		}),
		[t],
	);
};
